export default __webpack_public_path__ + "static/media/favorites-artisanpro-comp.4bc272e3.png";